<template>
  <div
    class="sidebar"
  >
    <base-card
      small
      class="tools"
    >
      <slot />
      <!-- <hr> -->
      <div>
        <base-button
          :disabled="disabled"
          class="custombutton preview__button"
          @click.native="preview"
        >
          <base-icon
            icon="preview"
          /> {{ $t('outreach.detail.actions.preview') }}
        </base-button>
      </div>
      <hr class="linehr">
      <draggable
        :list="widgetTypes"
        :group="{ name: 'widgets', pull: 'clone', put: false }"
        :sort="false"
        :disabled="disableDrag"
        :delay="isIPad || isTouchDevice ? 80 : 0"
        :delay-on-touch-only="isTouchDevice || isIPad"
      >
        <!-- Tools here -->
        <div
          v-for="(widget, index) in widgetTypes"
          :key="`widget_item_${index}`"
          class="tools__item"
          :type="widget.type"
          :data-type="widget.type"
          @click="clickedWidget(widget.type)"
        >
          <div
            ref="toolButton"
            class="tool"
            :type="widget.type"
            :data-type="widget.type"
          >
            <base-icon
              class="tool__icon"
              :icon="isIPad ? widget.iconLarge : widget.icon"
            />
            <base-text
              light
              class="tool__label"
            >
              {{ widget.label }}
            </base-text>
          </div>
        </div>
      </draggable>
    </base-card>
  </div>
</template>
<script>
import Whichbrowser from '@/components/mixins/whichbrowser';
import draggable from 'vuedraggable';

export default {

  name: 'DraftEditorWidgetsTools',
  components: {
    draggable,
  },
  mixins: [Whichbrowser],
  data() {
    return {
      widgetTypes: [{
        icon: 'images-row',
        iconLarge: 'images-row-large',
        label: this.$t('outreach.image.title'),
        type: 'image',
      }, {
        icon: 'text-box',
        iconLarge: 'text-box-large',
        label: this.$t('outreach.text.title'),
        type: 'text',
      }, {
        icon: 'product-row',
        iconLarge: 'product-row-large',
        label: this.$t('outreach.product.title'),
        type: 'product',
      }],
      disabledTint: false,
    };
  },
  computed: {
    widgets: {
      get() {
        return this.$store.state.entries.item.sections;
      },
      set(value) {
        return this.$store.commit('entries/updateSections', value);
      },
    },
    disabled() {
      return this.$store.state.sections.isLoading || ['saving', 'loading'].includes(this.patchStatus);
    },
    disableDrag() {
      return ['saving', 'loading'].includes(this.patchStatus);
    },
    patchStatus() {
      return this.$store.state.entries.status;
    },
  },
  watch: {
    patchStatus(newval) {
      if (['saving', 'loading'].includes(newval)) {
        window.setTimeout(() => {
          this.disabledTint = ['saving', 'loading'].includes(this.patchStatus);
        }, 2000);
      } else {
        this.disabledTint = false;
      }
    },
  },
  methods: {
    onAdd(type) {
      if (this.disableDrag) return;
      this.widgets.splice(this.widgets.length, 0, {
        type: `${type}-widget`,
        loading: true,
        collage_width: 800,
        collage_height: 640,
        // Used so that a product-row displays "choose your layout" when
        // user has not selected the number rows have not been selected
        product_row_width: -1,
      });
      this.$emit('save', ['sections', 'url']);
    },
    clickedWidget(widget) {
      this.$mixpanel.track('create_widget', {
        edit: this.$route.params.id,
        widget,
        account_id: this.$store.state.account.user.user.email,
      });
      this.onAdd(widget);
      this.$emit('isClicked');
    },
    preview() {
      this.$router.push({ name: 'PageEditorPreview' });
    },
  },
};
</script>
<style lang="scss" scoped>
$width: 182px;

.draggable-item {
  width: 100%;
}

.tools{
  // margin-top: 12px;
  padding-bottom: 15px;

  &--ipad {
    background: transparent;
    padding-bottom: 0;
    box-shadow: 0px 0px 10px 4px rgba(51, 51, 51, 0.1);
  }

  &--ipad ::v-deep .sl-card--condensed {
    padding: 0 !important;
  }
}

.editor .tool{
  width: 100%;
  margin-bottom: 20px;
  background: #FAF9F7;
}

.tool {
  /* background-color: white;
  max-width: 1114px; */
  //  d-flex flex-column align-items-center justify-content-center p-3 text-center
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: grab;
  font-size: 14px;
  transition: opacity .3s ease;
  border: 1px solid #C6C6C6;
  border-radius: 6px;
  height: 92px;
  margin: 12px 0;
  padding: 0 10px;

  &__label{
    line-height: 1;
    margin-top: 12px;
    font-weight: 300;
    font-size: 14px;
    line-height: 135%;
    color: #1B1B1B;
    text-align: center;

    &--ipad {
      font-size: 14px;
      margin-top: 14px;
    }
  }
  &__icon{
    max-width: 30px;
    margin: 0 auto;

    &--ipad {
      width: 40px;
      max-width: unset;
    }
  }

  &--ipad {
    margin: 0;
    padding: 0;
    background: white;
    border: inherit;
    border-radius: inherit;
    width: 105px;
    height: 105px;
  }
}

.tools-list--ipad > div:first-child {
  border-radius: 8px 8px 0 0;
  // border-bottom: 1px solid #D4D4D4;
}
// Note: I'm forcing child number 3 because the d&d is adding a new DOM element at the bottom of the list
.tools-list--ipad > .tools__item:nth-child(3) {
  border-radius: 0 0 8px 8px;
  // border-top: 1px solid #D4D4D4;
}

// Note: In the near future this should be changed to mediaquery instead of isIPad
.is-ipad{
  .tools__item + .tools__item > div{
    border-top: solid 0.5px $gray-light-2;
  }
  .sortable-drag > div {
    border-top: none !important;
    // background-color: red !important;
  }
}

.sidebar {
  // position: fixed;
  // top: $offsetTop + 16;
  // right: 0;
  // bottom: 0;
  // padding: 0;
  // margin-top:77px;
  max-width: 140px;
  width: 140px;
  margin-left: 16px;
  z-index: 99;
  position: sticky;
  top: 70px;
}

.divider {
  margin: 25px auto 25px;
  border: solid 1px #33333333;
  width: 90%;
  transform: scaleY(0.5);
}

.disabled-tool {
  transition: filter .3s ease, opacity .3s ease;
  filter: grayscale(100%);
  opacity: 0.5;
}
.custombutton {
  font-size: 14px;
  padding: 10px 8px;
  border-radius: 5px;
  margin: 0 6px;

  &--ipad {
    margin: 0;
  }
}
.custombutton:not(.base-button--inverse) {
  color: $black;
}
.custombutton > img {
  padding-right: 4px;
  margin-left: 4px;
  margin-right: 4px;
}

.previewicon--ipad {
  margin-left: 0 !important;
}
.preview__button {
  border: solid 1px #C6C6C6;
  border-radius: 8px;
  width: 100%;
  margin: 0;
  justify-content: center;
  height: 36px;
  // @media (min-width: map-get($breakpoints,'lg')) {
  //   display: none;
  // }
}
</style>
